import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { UsersDropdownRespSuccess } from '../types';
import { useAppContext } from '@contexts/app';

export const useBuildersDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { data, error, isFetching } = useQuery<UsersDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.builders,
    queryFn: () => queryFetch({ url: 'dropdowns/builders' }),
    placeholderData: (previousData) => previousData as UsersDropdownRespSuccess,
    enabled,
  });

  return {
    data,
    error,
    isLoading: isFetching,
  };
};
